import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {setDeleteMaterialId, setUpdateMaterialId} from "../../actions/material";
import {Link} from 'react-router-dom';
import MoneyFormat from "../layout/MoneyFormat";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faEye } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';
import { usePermission } from '../../hooks/usePermission';
import { useManagerPermissions } from '../../hooks/useManagerPermissions';

const MaterialItem = ({
                          setDeleteMaterialId,
                          setUpdateMaterialId,
                          material: {
                              id, name, unit_alternative, unit, in_stock,
                              multiplier,
                              price,
                              firm,
                              warehouse
                          },
                          number
                      }) => {
    const { userCan } = usePermission();
    const { canManagerEditMaterial, canManagerDeleteMaterial } = useManagerPermissions();

    // Reconstruct material object for permission checks
    const materialObject = {
        id, name, unit_alternative, unit, in_stock,
        multiplier, price, firm, warehouse
    };

    if (!userCan('view materials')) {
        return null;
    }

    const setDeleteMaterial = (id) => {
        setDeleteMaterialId(id);
    };

    const setUpdateMaterial = (id) => {
        setUpdateMaterialId(id);
    };

    return (
        <Fragment>
            <tr>
                <th scope="row">{number}</th>
                <td>{name}</td>
                <td>
                    {userCan('view firms') && firm?.id ? (
                        <Link to={`/firms/${firm.id}`}>
                            {firm.name}
                        </Link>
                    ) : (
                        firm?.name || ''
                    )}
                </td>
                <td>
                    {userCan('view warehouses') && warehouse?.id ? (
                        <Link to={`/warehouses/${warehouse.id}`}>
                            {warehouse.name}
                        </Link>
                    ) : (
                        warehouse?.name || ''
                    )}
                </td>
                <td>{in_stock}</td>
                <td>{unit?.name} </td>
                <td>{multiplier} x</td>
                <td>{unit_alternative?.name}</td>
                <td><MoneyFormat value={price}/> so'm</td>
                <td>
                    <div className="d-flex gap-2">
                        {userCan('view materials') && (
                            <Link to={`materials/${id}`}>
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                >
                                    <FontAwesomeIcon icon={faEye} />
                                </Button>
                            </Link>
                        )}
                        {canManagerEditMaterial(materialObject) && (
                            <Button
                                variant="outline-primary"
                                size="sm"
                                className="d-flex align-items-center justify-content-center"
                                style={{ width: '32px', height: '32px', padding: 0 }}
                                onClick={() => setUpdateMaterial(id)}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                            </Button>
                        )}
                        {canManagerDeleteMaterial(materialObject) && (
                            <Button
                                variant="outline-danger"
                                size="sm"
                                className="d-flex align-items-center justify-content-center"
                                style={{ width: '32px', height: '32px', padding: 0 }}
                                onClick={() => setDeleteMaterial(id)}
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </Button>
                        )}
                    </div>
                </td>
            </tr>
        </Fragment>
    );
};

MaterialItem.defaultProps = {
    showActions: true,
};

MaterialItem.propTypes = {
    material: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        unit_alternative: PropTypes.shape({
            name: PropTypes.string
        }),
        unit: PropTypes.shape({
            name: PropTypes.string
        }),
        in_stock: PropTypes.number,
        multiplier: PropTypes.number,
        price: PropTypes.number,
        firm: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string
        }),
        warehouse: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string
        })
    }).isRequired,
    number: PropTypes.number.isRequired,
    setDeleteMaterialId: PropTypes.func.isRequired,
    setUpdateMaterialId: PropTypes.func.isRequired
};

export default connect(null, {setDeleteMaterialId, setUpdateMaterialId})(MaterialItem);
